export default __webpack_public_path__ + "media/images/home/slide_summer_break_2026_lg-d79809cd9297aee041c0ece3abe7a7d8.jpg";